// Returns black or white depending on how light/dark the given hex color is,
// so text stays readable on top of the clinic's brand color.
export function contrastText(hex) {
  if (!hex) return "#ffffff";
  let c = hex.replace("#", "").trim();
  if (c.length === 3) c = c.split("").map((x) => x + x).join("");
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return "#ffffff";
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#000000" : "#ffffff";
}

export const BRAND_DEFAULT = "#1C352D";
